import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {
  return (
    <></>
  )
}
